import {
  Route,
  BrowserRouter as Router,
  Routes,
  Navigate,
} from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Aboutus from "./pages/Aboutus";
import Contactus from "./pages/Contactus";
import Layout from "./components/Layout";
import Career from "./pages/Career";

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="home" element={<Home />} />
          <Route path="aboutus" element={<Aboutus />} />
          <Route path="services" element={<Services />} />
          <Route path="career" element={<Career />} />
          <Route path="contactus" element={<Contactus />} />
          <Route path="*" element={<Navigate to="" />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
